//------------------------------------------------------------------------------
// 地図部品
//------------------------------------------------------------------------------
import '@arcgis/map-components/components/arcgis-zoom';
import { ArcgisZoom } from "@arcgis/map-components-react";

/**
 * ズームボタン (ツールチップ編集版)
 */
export default function MapZoomButton(props) {
  return (
    <ArcgisZoom
      {...props}
      messageOverrides={{
        zoomOut: '地図を縮小します。',
        zoomIn: '地図を拡大します。'
            + '\nSHIFT+ドラッグで拡大することもできます。',
      }}
    />
  );
}
